import { useQuery } from '@tanstack/react-query';
import { getSpecialties } from '@uplift/api';
import { SearchListContained } from '@uplift/ui-v2';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { useL10n } from '@uplift/hooks';

export type SpecialtiesFormProps = {
  hideLabel?: boolean;
};

export const SpecialtiesForm: React.VFC<SpecialtiesFormProps> = props => {
  const l10n = useL10n();
  const { data: specialties = [], isInitialLoading: loading } = useQuery(PROFILE_ROW_QUERY_KEYS.specialties, async () => {
    const response = await getSpecialties();

    return response.data;
  });

  return (
    <div style={{ height: '100%' }}>
      <SearchListContained
        name="specialties"
        label={props.hideLabel ? undefined : 'Select all specialties that you have experience in'}
        options={specialties}
        getOptionLabel={(option) => option.name}
        placeholder="Search for specialties"
        selectionOverviewText="specialties selected"
        optionVariant="checkbox"
        emptyMessage={<>Can’t find a specialty? Email us at <b>{l10n.helpEmail}</b> with the specialty you’re looking for.</>}
        loading={loading}
        fullPageMobileView={true}
      />
    </div>
  );
};
